import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AmbientPage } from './ambient';

@NgModule({
  declarations: [
    AmbientPage,
  ],
  imports: [
    IonicPageModule.forChild(AmbientPage),
  ],
  exports:[
    AmbientPage
  ]
})
export class AmbientPageModule {}



// WEBPACK FOOTER //
// ./src/pages/ambient/ambient.module.ts